export default "__VITE_ASSET__DJLyvumk__"